import * as React from 'react';
import CardComponent from './CardComponent';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import TailoredActionName from '../store/schema/telemetry/TailoredActionName';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import populateExpandActionDataPoint from '../utils/telemetry/populateExpandActionDataPoint';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import isEntityTypeEditable from '../utils/view/isEntityTypeEditable';

let classNames = require('classnames');
let styles = require('./Txp.scss');

export interface BusStopState {
    isExpanded: boolean;
}

export interface BusStopProps {
    cardItem: CardItem;
    txpStyle: TxpStyle;
    expandOnMount?: boolean;
    txpConfiguration: TxpConfiguration;
    isSpinnerShown?: boolean;
    onSpinnerStateChanged?: (state: boolean) => void;
}

export default class BusStopItemComponent extends React.Component<BusStopProps, BusStopState> {
    constructor(props: BusStopProps) {
        super(props);
        this.state = {
            isExpanded: !!props.expandOnMount,
        };
    }

    render() {
        let firstLineStyle = this.state.isExpanded
            ? classNames([styles.busStopFirstLine, styles.busStopFirstLineExpand])
            : styles.busStopFirstLine;
        let {
            cardItem,
            txpStyle,
            txpConfiguration,
            isSpinnerShown,
            onSpinnerStateChanged,
        } = this.props;
        let busStopData = cardItem.busStopData;
        return (
            <div className={styles.busStop} role="listitem">
                <DefaultButton
                    aria-expanded={this.state.isExpanded}
                    onClick={() => this.onExpandCard()}
                    className={firstLineStyle}>
                    <Icon className={styles.busStopIcon} iconName={busStopData.icon} />
                    <div className={styles.busStopLabel}>{busStopData.busStopLabel}</div>
                    <div
                        className={
                            isEntityTypeEditable(cardItem.entityType)
                                ? styles.editableBusStopText
                                : styles.busStopText
                        }>
                        {busStopData.busStopText}
                    </div>
                    <span className="screenReaderOnly">{busStopData.ariaBusStopText}</span>
                </DefaultButton>
                <div>
                    {this.state.isExpanded && (
                        <div className={styles.cardInBusStop}>
                            <CardComponent
                                cardItem={cardItem}
                                txpStyle={txpStyle}
                                txpConfiguration={txpConfiguration}
                                isSpinnerShown={isSpinnerShown}
                                onSpinnerStateChanged={onSpinnerStateChanged}
                            />
                        </div>
                    )}
                    {!this.state.isExpanded && (
                        <div aria-hidden={true} className={styles.collapsedText}>
                            {busStopData.collapsedText}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private onExpandCard = () => {
        let { cardItem, txpConfiguration } = this.props;

        this.setState({
            isExpanded: !this.state.isExpanded,
        });

        if (txpConfiguration.datapointLogger) {
            const dataPoint = populateExpandActionDataPoint(cardItem, !this.state.isExpanded);
            txpConfiguration.datapointLogger(dataPoint, TailoredActionName.ExpandCard);
        }
    };
}
